module.exports = __webpack_public_path__ + "static/img/view2.f105bb5.png";


//////////////////
// WEBPACK FOOTER
// ./public/img/view2.png
// module id = 99L0
// module chunks = 0